import { Link } from 'react-router-dom';
import PageShell from '@/components/feature/PageShell';
import Container from '@/components/base/Container';

export default function NotFound() {
  return (
    <PageShell>
      <section className="bg-background-50 py-24 md:py-40">
        <Container className="text-center">
          <p className="text-[120px] md:text-[200px] font-light leading-none tracking-[-0.05em] text-primary-200">404</p>
          <h1 className="mt-4 text-2xl md:text-4xl font-medium tracking-tight text-foreground-950">This page needs a repair.</h1>
          <p className="mx-auto mt-4 max-w-sm text-[15px] text-foreground-600">The page you&apos;re looking for doesn&apos;t exist or has moved.</p>
          <div className="mt-8 flex flex-col sm:flex-row justify-center gap-2.5">
            <Link to="/" className="inline-flex h-12 items-center justify-center whitespace-nowrap rounded-full bg-primary-500 px-7 text-sm text-white hover:bg-primary-600">Back to Home</Link>
            <Link to="/services" className="inline-flex h-12 items-center justify-center whitespace-nowrap rounded-full border border-background-200 px-7 text-sm text-foreground-950 hover:bg-background-100">View Services</Link>
          </div>
        </Container>
      </section>
    </PageShell>
  );
}